import Divider from "@mui/material/Divider";
import Grid2 from "@mui/material/Grid2";

export function ShowMoreDescription({
  description,
  index,
  length,
  spaceStyleY
}: Readonly<{
  description: string | null;
  index: number;
  length: number;
  spaceStyleY: number;
}>) {
  return (
    <>
      <Grid2 pl={2} py={spaceStyleY}>
        {description}
      </Grid2>
      {index !== length - 1 && (
        <Divider
          sx={{
            my: spaceStyleY,
            opacity: "0.6"
          }}
        />
      )}
    </>
  );
}
